export const COTIZACION_FORM = {
    name: "",
    email: "",
    phone: "",
    message: ""
};